import { Instance, types } from "mobx-state-tree";
import { AppPermission } from "@closerplatform/spinner-openapi";

export const Role = types
  .model("Role", {
    id: types.identifier,
    orgId: types.string,
    name: types.string,
    permissions: types.array(
      types.enumeration<AppPermission>("AppPermission", Object.values(AppPermission))
    )
  })
  .actions((self) => ({
    findPermission(permission: AppPermission) {
      return self.permissions.find((perm) => perm === permission);
    }
  }));

export interface IRole extends Instance<typeof Role> {}
